import React from 'react';
import { motion } from 'framer-motion';
import { Info, PhoneMissed } from 'lucide-react';
import { DeckPhoneFrame } from './DeckPhoneFrame';
import { nativeCallLog } from '../../data/deckSlide2';
interface NativeCallLogPhoneProps {
  scale?: number;
  /** Delay (s) before the individual log rows settle in. */
  rowDelay?: number;
}

/**
 * A generic, native-style phone call log — deliberately NOT the Vexu app.
 * It shows who called and nothing about why.
 */
export function NativeCallLogPhone({
  scale = 0.62,
  rowDelay = 0
}: NativeCallLogPhoneProps) {
  return <DeckPhoneFrame scale={scale} surfaceClassName="bg-[#F2F2F7]" data-id="element-230" data-mp="ixz9rvkr6fbz">
      <div className="h-full flex flex-col select-none" aria-hidden="true" data-id="element-231" data-mp="42jgvtvwsph6">
        <div className="px-5 pt-2 pb-3 bg-[#F2F2F7]" data-id="element-232" data-mp="914hhuf2pb65">
          <div className="flex items-center justify-between" data-id="element-233" data-mp="2ota2hz6libls">
            <h2 className="text-[32px] font-bold tracking-tight text-black" data-id="element-234" data-mp="2orqokf8ewcn6">
              Recents
            </h2>
            <span className="text-[15px] text-[#007AFF]" data-id="element-235" data-mp="2tqa8ka3g3ecw">Edit</span>
          </div>
          <div className="mt-3 grid grid-cols-2 rounded-[9px] bg-black/[0.06] p-[2px]" data-id="element-236" data-mp="2xoql0ybqtoko">
            <span className="text-center text-[13px] font-medium text-black/60 py-1" data-id="element-237" data-mp="2sqfb6nlg7e2g">
              All
            </span>
            <span className="text-center text-[13px] font-semibold text-black rounded-[7px] bg-white py-1 shadow-sm" data-id="element-238" data-mp="36msix506k13q">
              Missed
            </span>
          </div>
          <p className="mt-3 text-[12px] font-medium text-black/40" data-id="element-239" data-mp="3glrtit4ia6td">
            17 missed calls today
          </p>
        </div>

        <div className="flex-1 bg-white" data-id="element-240" data-mp="3blvpitvt6fdt">
          {nativeCallLog.map((entry, i) => <motion.div key={`${entry.name}-${entry.time}`} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.45,
          delay: rowDelay + i * 0.07
        }} className="flex items-center gap-3 pl-5 pr-4 h-[62px] border-b border-black/[0.07]" data-id="element-241" data-mp="3pelftaide6gq" data-mpi={i}>
              <PhoneMissed className="w-[18px] h-[18px] text-[#FF3B30] flex-shrink-0" strokeWidth={2} data-id="element-242" data-mp="2s1bfe14ao8op" />
              <div className="flex-1 min-w-0" data-id="element-243" data-mp="2w36kzht9d88a">
                <p className="text-[16px] font-semibold text-[#FF3B30] truncate" data-id="element-244" data-mp="311zu6y1iid2n">
                  {entry.name}
                  {entry.repeat ? <span className="font-normal text-[#FF3B30]/70" data-id="element-245" data-mp="35tre4pq5xkjt">
                      {' '}
                      ({entry.repeat})
                    </span> : null}
                </p>
                <p className="text-[13px] text-black/45 truncate" data-id="element-246" data-mp="3fsqp4eyehs9z">
                  {entry.detail}
                </p>
              </div>
              <span className="text-[14px] text-black/40 flex-shrink-0" data-id="element-247" data-mp="3oru8zl5e6bpj">
                {entry.time}
              </span>
              <Info className="w-[19px] h-[19px] text-[#007AFF] flex-shrink-0" strokeWidth={1.6} data-id="element-248" data-mp="1pf9m8ubou2ug" />
            </motion.div>)}
        </div>
      </div>
    </DeckPhoneFrame>;
}